module.exports = __webpack_public_path__ + "baefd4bd39bccaf046ce39ebcb71eb80.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-84.svg
// module id = 601
// module chunks = 0